// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var GoogleMapReact = require("google-map-react").default;
var GoogleMapReactPositionalChild = require("./googleMapReactPositionalChild").default;

var make = GoogleMapReactPositionalChild;

function BrowserBindings_GoogleMapReact$PositionalChild(Props) {
  var param = Props.geoPoint;
  var children = Props.children;
  return React.createElement(make, {
              children: children,
              lat: param.latitude,
              lng: param.longitude
            });
}

function BrowserBindings_GoogleMapReact(Props) {
  var className = Props.className;
  var children = Props.children;
  var defaultZoom = Props.zoom;
  var key = Props.token;
  var param = Props.geoPoint;
  var lng = param.longitude;
  var lat = param.latitude;
  var tmp = {
    defaultZoom: defaultZoom,
    bootstrapURLKeys: {
      key: key
    },
    defaultCenter: {
      lat: lat,
      lng: lng
    },
    draggable: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    panControl: false,
    key: Relude_Float.toString(lat) + Relude_Float.toString(lng)
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  return React.createElement(GoogleMapReact, tmp);
}

function PositionalChild_makeProps(prim, prim$1, prim$2, prim$3) {
  var tmp = {
    geoPoint: prim,
    children: prim$1
  };
  if (prim$2 !== undefined) {
    tmp.key = Caml_option.valFromOption(prim$2);
  }
  return tmp;
}

var PositionalChild = {
  makeProps: PositionalChild_makeProps,
  make: BrowserBindings_GoogleMapReact$PositionalChild
};

function makeProps(prim, prim$1, prim$2, prim$3, prim$4, prim$5, prim$6) {
  var tmp = {
    zoom: prim$2,
    token: prim$3,
    geoPoint: prim$4
  };
  if (prim !== undefined) {
    tmp.className = Caml_option.valFromOption(prim);
  }
  if (prim$1 !== undefined) {
    tmp.children = Caml_option.valFromOption(prim$1);
  }
  if (prim$5 !== undefined) {
    tmp.key = Caml_option.valFromOption(prim$5);
  }
  return tmp;
}

var make$1 = BrowserBindings_GoogleMapReact;

exports.PositionalChild = PositionalChild;
exports.makeProps = makeProps;
exports.make = make$1;
/* make Not a pure module */
